import { RESEND_INVITE_TOKEN } from 'actions/Types';

export default function inviteResent(state = null, action) {
  if (action.type === `${RESEND_INVITE_TOKEN}_SUCCESS`) {
    return action.payload;
  }

  return state;
}
